import React, { FC } from 'react';
import useLiveStreamStatusSubscriber from 'components/pictureInPicture/useLiveStreamStatusSubscriber';

interface LiveStreamStatusSubscriberProps {
  targetBoothId?: string
}

const LiveStreamStatusSubscriber: FC<LiveStreamStatusSubscriberProps> = ({ targetBoothId }) => {
  useLiveStreamStatusSubscriber(targetBoothId);
  return null;
};

export default LiveStreamStatusSubscriber;
